import { RadioButtonGroup } from 'Components/FormField/RadioButtonGroup/RadioButtonGroup';
import { Text } from 'Components/Text/Text';
import { DueDiligenceSelectableAnswerOption } from 'Models/DueDiligence';

interface QuestionSingleSelectProps {
    answerOptions: DueDiligenceSelectableAnswerOption[];
    formFieldLabelId: string;
    onAnswerChanged: (answerIndex?: number) => void;

    defaultSelectedIndex?: number;
    disabled?: boolean;
    questionText?: string;
}

export const QuestionSingleSelect = (props: QuestionSingleSelectProps) => {
    return (
        <>
            {props.questionText && <Text variant="Text2">{props.questionText}</Text>}
            <RadioButtonGroup
                clearable
                formFieldLabel="Answer"
                disabled={props.disabled}
                formFieldLabelId={props.formFieldLabelId}
                onChange={props.onAnswerChanged}
                options={props.answerOptions.map((option, index) => ({
                    isUnacceptable: option.is_unacceptable && index === props.defaultSelectedIndex,
                    label: option.text,
                    value: index,
                }))}
                defaultValue={props.defaultSelectedIndex}
            />
        </>
    );
};
